import { Route, Routes } from "react-router-dom";
import LandingPage from "./container/Landingpage";
import SubPage from "./container/Packages/index";
import Header from "./container/Header";
import NotFound from "./Error/NotFound";
import Menu from "./container/WeeklyMenu";
function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Header />}>
          <Route index element={<LandingPage />} />
          <Route path="/Packages" element={<SubPage />} />
          <Route path="/Menu" element={<Menu />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
